export default {
      id: "icon-arrow-usage",
      viewBox: "0 0 447.243 447.243",
      url: __webpack_public_path__ + "icons.svg#icon-arrow",
      toString: function () {
        return this.url;
      }
    }